import { render, staticRenderFns } from "./FspAcknowledgeFormLegacy.vue?vue&type=template&id=94deca2e&"
import script from "./FspAcknowledgeFormLegacy.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormLegacy.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormLegacy.vue?vue&type=style&index=0&id=94deca2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports